<template>
  <div class="notification">
    <div :class="{
      'notification__info-border': isInfo,
      'notification__success-border': isSuccess,
      'notification__warning-border': isWarning,
      'notification__error-border': isError
    }">
      <span>
        <notification-icon :notification="notification" class="notification__icon"/>
      </span>
      <span class="notification__button">
        <icon name="times-circle" scale="1.4" @click.native="deleteNotification"/>
      </span>
      {{notification.description}}
    </div>
    <template v-if="action">
      <div class='notification__action-block'>
        <oval-button
          class='notification__action'
          @click.native="actionCommand"
        >
          {{action.title}}
        </oval-button>
      </div>
    </template>
  </div>
</template>

<script>
import NotificationIcon from './NotificationIcon'
import {alertLevels} from './mixins'
import 'vue-awesome/icons/times-circle'
import Icon from 'vue-awesome/components/Icon'
import {OvalButton} from '@/components/common/ovalLabel'

export default {
  components: {
    NotificationIcon,
    Icon,
    OvalButton
  },
  mixins: [alertLevels],
  props: {
    notification: Object,
    actionEngine: {
      type: Object,
      default: null
    },
    dismiss: Function
  },
  computed: {
    action () {
      return this.actionEngine && this.actionEngine.get(this.notification)
    }
  },
  methods: {
    deleteNotification () {
      this.$emit('delete', this.notification)
    },
    actionCommand () {
      if (this.action) {
        this.dismiss()
        this.action.action(this.notification)
      }
    }
  }
}
</script>

<style lang="scss">
$thick: 2px;

.notification {
  padding: 5px 5px 0px 5px;
  width: 700px;
  
  &:not(:last-child) {
    margin-bottom: 5px;
  }

  &__action-block {
    height: 38px;
  }

  &__action {
    background-color: green;
    margin-left: 5px;
    border-color: green !important;
    color: white;
    float: right;
  }

  &__button {
    position: relative;
    float: right;
    cursor: pointer;
    margin-left: 5px;
  }

  &__info-border {
    border: $thick solid #4CBEE7;
  }

  &__success-border {
    border: $thick solid rgb(75, 207, 42);
  }

  &__warning-border {
    border: $thick solid rgb(235, 214, 31);
  }

  &__error-border {
    border: $thick solid red;
  }
}
</style>




// WEBPACK FOOTER //
// Notification.vue?b1ed6e6e